"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function FileSizeToString(bytes) {
    var Kilo = 1024;
    if (Math.abs(bytes) < Kilo) {
        return bytes + " Bytes";
    }
    var units = ['kB', 'MB', 'GB', 'TB'];
    var u = -1;
    var byteValue = bytes;
    do {
        byteValue /= Kilo;
        u += 1;
    } while (Math.round(Math.abs(byteValue) * 10) / 10 >= Kilo &&
        u < units.length - 1);
    return byteValue.toFixed(1) + " " + units[u];
}
exports.FileSizeToString = FileSizeToString;
//# sourceMappingURL=FileSizeHelper.js.map